module.exports = __webpack_public_path__ + "static/media/bbq_shrimp.5fa586ad.jpg";